export default {
  uploading_x_of_y_files: 'Uploading {currentUploading} of {filesCount} files.',
};
